export default __webpack_public_path__ + "static/media/subscription.352724fd.png";